/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerPricingResource } from './';
import {
    FreelancerPricingResourceFromJSON,
    FreelancerPricingResourceFromJSONTyped,
    FreelancerPricingResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerDetailsResource
 */
export interface FreelancerDetailsResource {
    /**
     * 
     * @type {string}
     * @memberof FreelancerDetailsResource
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerDetailsResource
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerDetailsResource
     */
    firstname?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerDetailsResource
     */
    lastname?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerDetailsResource
     */
    fullname?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerDetailsResource
     */
    jobTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerDetailsResource
     */
    profileId?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerDetailsResource
     */
    photoUrl?: string;
    /**
     * 
     * @type {FreelancerPricingResource}
     * @memberof FreelancerDetailsResource
     */
    pricing?: FreelancerPricingResource;
}

/**
 * Check if a given object implements the FreelancerDetailsResource interface.
 */
export function instanceOfFreelancerDetailsResource(value: object): value is FreelancerDetailsResource {
    return true;
}

export function FreelancerDetailsResourceFromJSON(json: any): FreelancerDetailsResource {
    return FreelancerDetailsResourceFromJSONTyped(json, false);
}

export function FreelancerDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'fullname': json['fullname'] == null ? undefined : json['fullname'],
        'jobTitle': json['jobTitle'] == null ? undefined : json['jobTitle'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
        'pricing': json['pricing'] == null ? undefined : FreelancerPricingResourceFromJSON(json['pricing']),
    };
}

export function FreelancerDetailsResourceToJSON(value?: FreelancerDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'email': value['email'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'fullname': value['fullname'],
        'jobTitle': value['jobTitle'],
        'profileId': value['profileId'],
        'photoUrl': value['photoUrl'],
        'pricing': FreelancerPricingResourceToJSON(value['pricing']),
    };
}

